import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import ca from './locales/ca.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import ar from './locales/ar.json';

export const resources = {
  en: { translation: en },
  es: { translation: es },
  pt: { translation: pt },
  ca: { translation: ca },
  fr: { translation: fr },
  de: { translation: de },
  ar: { translation: ar },
} as const;

i18n.use(initReactI18next).init({
  resources,
  lng: 'en', // default language
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;